import { settingsPagePath } from '@/shared/constants'
import { epgPagePath } from '@/shared/constants/epgConstants'
import { homePagePath } from '@/shared/constants/homeConstants'
import { tvPagePath } from '@/shared/constants/tvConstants'
import { vodPagePath } from '@/shared/constants/vodConstants'
import { useAppStore, useTVStore, useVisibilityStore } from '@/shared/store'

const useVisibleContent = () => {
    const {
        setTvContentVisible,
        setEpgContentVisible,
        setVodContentVisible,
        setHomeContentVisible,
        setSettingsContentVisible,
    } = useVisibilityStore()
    const { isPIPMode } = useTVStore()
    const { isUserLoggedIn } = useAppStore()
    const setActualContentVisible = (actualPath: string) => {
        if (isUserLoggedIn) {
            switch (actualPath) {
                case homePagePath:
                    setHomeContentVisible()
                    break
                case tvPagePath:
                    setTvContentVisible(true)
                    break
                case epgPagePath:
                    setEpgContentVisible(isPIPMode)
                    break
                case vodPagePath:
                    setVodContentVisible()
                    break
                case settingsPagePath:
                    setSettingsContentVisible()
                    break
            }
        }
    }
    return { setActualContentVisible }
}

export default useVisibleContent
